import { useFlowStore } from '../store/flowStore'
import { EDGE_PATH_TYPES, type EdgePathType } from '../types'

const EDGE_TYPE_LABELS: Record<EdgePathType, string> = {
  smoothstep: 'Curva suave',
  bezier: 'Bézier',
  step: 'Degrau',
  straight: 'Reta',
}

export function ConnectionSettings() {
  const edgeType = useFlowStore((s) => s.edgeType)
  const setEdgeType = useFlowStore((s) => s.setEdgeType)
  const readOnly = useFlowStore((s) => s.readOnly)
  const presentationMode = useFlowStore((s) => s.presentationMode)

  if (readOnly || presentationMode) return null

  return (
    <section className="sidebar-section sidebar-connections">
      <h2 className="sidebar-title">Novas conexões</h2>
      <label className="field" htmlFor="sidebar-edge-type">
        <span>Tipo de linha</span>
        <select
          id="sidebar-edge-type"
          value={edgeType}
          onChange={(e) => setEdgeType(e.target.value as EdgePathType)}
          title="Estilo das novas conexões"
        >
          {EDGE_PATH_TYPES.map((type) => (
            <option key={type} value={type}>
              {EDGE_TYPE_LABELS[type]}
            </option>
          ))}
        </select>
      </label>
    </section>
  )
}
